// Sverige
export default {
	status: {
		400: "Begäran misslyckades! Försök igen senare",
		401: "Inloggningssessionen har löpt ut! Logga in igen",
		403: "Nuvarande konto har inte åtkomstbehörighet",
		404: "Resursen du försöker komma åt finns inte",
		405: "Felaktig begäran! Försök igen senare",
		408: "Begäran tog för lång tid! Försök igen senare",
		500: "Tjänsten stötte på ett undantag",
		990: "Ditt konto har varit spärrat under en längre tid på grund av oavslutade uppgifter",
		10030008: "Vänligen returnera assistansfonden innan du ansöker om kontantuttag",
		10030010: "Inbjudningskoden finns inte",
		10030011: "Överskred det maximala antalet incheckningstillfällen",
		10030012: "Uppfyller inte incheckningsvillkoren, slutför uppgiften först",
		10030013: "Inloggningskonfigurationsfel, kontakta kundtjänst",
		10030014: "Inte inom den tillåtna tidsperioden",
		10030015: "Medlemmen finns inte",
		10030016:
			"Kära användare: Grattis! Du har framgångsrikt slutfört 100 % av din produktkampanj. Vänligen kontakta plattformens support för att begära en återställning.",
		10030017: "Kan inte matcha produkt, kontakta kundtjänst",
		10030018: "Otillräcklig kontosaldo",
		10030019: "Kontot har inaktiverats",
		10030020: "Konto förbjudet från handel",
		10030021: "Kontouttag förbjudet",
		10030022: "Transaktionslösenordsfel",
		10030023: "Uttagskontot är inte bundet, bind uttagskontot först",
		10030024: "Gammalt lösenordsfel",
		10030027: "Ditt uttag är begränsat. Kontakta kundtjänst för mer information",
		10030028: "Låga kreditpoäng hindrar dig från att ta ut pengar",
		10030030: "Inte inom den tillåtna tidsperioden",
		10030031: "Kontakta kundtjänst för att återställa dagens uppgift",
		10030050: "Beställningen har gått ut. Vänligen kontakta kundtjänst för hjälp."
	},
	errorHandler: {
		InternalError: "Internt fel i JavaScript-motorn",
		ReferenceError: "Objektet hittades inte",
		TypeError: "Felaktig typ eller objekt används",
		RangeError: "Parameter utanför området vid användning av inbyggda objekt",
		SyntaxError: "Syntaxfel",
		EvalError: "Felaktig användning av Eval",
		URIError: "URI-fel",
		UnknownError: "Okänt"
	},
	Network: {
		timedout: "Begäran tog för lång tid! Försök igen senare",
		error: "Nätverksfel! Försök igen senare"
	},
	request: {
		NoMoreData: "Inga fler data",
		OnlyImage: "Ladda endast upp bildfiler.",
		FileMaxSize: "Filstorleken överskrider det maximala värdet, vilket är {0}M"
	},
	response: {
		loading: "Laddar",
		success: "Framgång",
		fail: "Misslyckande",
		complete: "Komplett"
	},
	page: {
		noVerify: "Plånbok ej verifierad, vänligen verifiera plånboken först",
		notexist: "Tyvärr, sidan du försöker komma åt finns inte~"
	}
};
